module.exports = __webpack_public_path__ + "img/how_it_works_2.791d3055.png";